










































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Icon from '@/components/Icon.vue'
import Password from '@/components/inputs/Password.vue'
import { UserModule } from '@/store/modules/user.module'
import Api from '@/api'
import Input from '@/components/inputs/Input.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { IResident } from '@zunta/configurations'
import { User } from '@/classes/User'
import { ResidentModule } from '@/store/modules/resident.module'
import MigrateToV2Popup from './components/MigrateToV2Popup.vue'

@Component({
  components: {
    Input,
    Icon,
    Password,
    ErrorMessages,
    MigrateToV2Popup,
  }
})
export default class ResidentEnter extends Vue {
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  user: User | null = null
  year: number = new Date().getFullYear()
  code: string = ''
  residentLastName: string = ''
  isInvalidCode: boolean = false
  isValidCode: boolean = true
  isSubmitting: boolean = false
  isCodeChecked: boolean = false
  isResidentChecked: boolean = false
  residentResponseError: string = ''
  residentId: number | null = null
  isChainMigratedToV2 = false
  showMigrateToV2Popup = false
  residentChainMigrationData: Partial<IResident> | null = null;

  async mounted () {
    const code = this.$route.params.code || this.$route.query.code
    if (code) {
      this.code = code as string
      await this.checkCode()
    }
  }

  async next (): Promise<void> {
    if (!this.validate()) {
      return
    }
    this.isInvalidCode = false
    this.isSubmitting = true
    await this.checkCode()
    this.isSubmitting = false
  }

  checkIfNeedToFormatCode (code: string): string {
    const regex = /^(.{3}-.{3})$/gm
    if (regex.test(code)) {
      return code
    } else {
      const a = code.substr(0, 3)
      const b = code.substr(3, 3)
      return `${a}-${b}`.toUpperCase()
    }
  }

  async checkCode (): Promise<void> {
    const result = await this.userModuleInstance.checkOneTimeCode(this.checkIfNeedToFormatCode(this.code))
    result === 'OK'
        ? this.isCodeChecked = true
        : this.isInvalidCode = true
  }

  async goToSignUp (): Promise<void> {
    if (this.residentId && this.isChainMigratedToV2) {
      this.residentChainMigrationData = await this.residentModuleInstance.getResidentChainMigrationData(this.residentId)
      this.showMigrateToV2Popup = true
      return
    }
    this.setUser()
    if (this.isCodeChecked) {
      localStorage.setItem('zunta_oneTimeCode', this.code)
    }
    const isActiveChain = await this.getIsActiveChain()
    if (isActiveChain) {
      await this.$router.push({ name: 'residentSignUp' })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Chain Is Deactivated',
        header: `Create Account`,
        icon: 'warning'
      })
    }
  }

  async createTempUser (): Promise<void> {
    if (this.isChainMigratedToV2) {
      return Api.v2.redirectTempResidentToV2(this.code, this.residentLastName)
    }
    const result = await this.userModuleInstance.createTempUser(this.code)
    if (result !== 'OK') {
      return
    }
    this.setUser()
    if (this.user && this.user.getResidents().length) {
      const isActiveChain = await this.getIsActiveChain()
      if (isActiveChain) {
        await this.$router.push({
          name: 'resident-general'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Chain Is Deactivated',
          header: `Continue As Guest`,
          icon: 'warning'
        })
      }
    }
  }

  async getIsActiveChain (): Promise<boolean> {
    return true
    // if (!this.user) {
    //   return false
    // }
    // await this.chainModuleInstance.getChainByResident(this.user.getResidents()[0])
    // return !!this.chainModuleInstance.chain && this.chainModuleInstance.chain.status === EChainStatus.ACTIVE
  }

  setUser () {
    this.user = Api.getUser()
  }

  validate (): boolean {
    this.isValidCode = true
    this.isValidCode = !!(this.code && this.code.trim().length)
    return this.isValidCode
  }

  async checkResident () {
    const response = await this.userModuleInstance.checkResidentName({
      lastName: this.residentLastName,
      code: this.code
    })
    this.isChainMigratedToV2 = response.chainMigratedToV2
    this.residentId = response.residentId
    if (response.valid) {
      this.residentModuleInstance.SET_RESIDENT_CODE_RECORD(response.code)
      this.isResidentChecked = true
      return
    }
    this.isResidentChecked = false
    this.residentResponseError = response.error
  }

  clearResidentInput () {
    this.residentLastName = ''
    this.residentResponseError = ''
    this.isCodeChecked = false
    this.isResidentChecked = false
  }
}
